import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { tutorApi } from '../../services/api';
import { TutorResponse } from '../../types';
import {
  fetchSolutionRequest,
  fetchSolutionSuccess,
  fetchSolutionFailure,
} from '../slices/tutorSlice';
import { showToast } from '../../utils/toast';

// Worker saga: makes API call when fetchSolutionRequest is dispatched
function* fetchSolutionSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    // Try to make API call
    const response: TutorResponse = yield call(tutorApi.getSolution, action.payload);
    yield put(fetchSolutionSuccess(response));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch solution';
    
    // Log the error
    console.warn('API call failed:', errorMessage);

    // Default behavior: show error state in UI
    yield put(fetchSolutionFailure(errorMessage));
    showToast.error(errorMessage);
  }
}

// Watcher saga: watches for fetchSolutionRequest actions
function* watchFetchSolution() {
  yield takeLatest(fetchSolutionRequest.type, fetchSolutionSaga);
}

// Root saga
export default function* tutorSaga() {
  yield watchFetchSolution();
}
